import { Injectable } from '@angular/core';
import { IndexedDBService } from './indexed-db.service';
import { SharedConstants } from '@formbird/types';
import { UtilDocumentId } from '@formbird/shared';
import { OfflineStatusService } from '../offline-status/offline-status.service';


const MAX_JSON_SIZE = 32768; // 32KB in bytes
const logger = console;

@Injectable({
  providedIn: 'root',
})
export class ErrorDocumentService {
    constructor(private indexedDBService: IndexedDBService, private offlineStatusService: OfflineStatusService) {}

    private truncateDocumentJSON = (document) => {
        const jsonString = JSON.stringify(document);
        if (jsonString.length > MAX_JSON_SIZE) {
            return jsonString.substring(0, MAX_JSON_SIZE) + "... [TRUNCATED]";
        }
        return jsonString;
    };

    private createErrorDoc = (documentId, document, error, category, additionalFields = {}) => {
        return {
            documentId: UtilDocumentId.generateId(),
            errorDocumentJSON: this.truncateDocumentJSON(document),
            errorMessage: error.message || "Unknown error",
            errorStack: error.stack,
            errorCode: error.code || "No code",
            errorCategory: category,
            errorDocumentId: documentId,
            systemHeader: {
                systemType: SharedConstants.SYSTEM_TYPE_ERROR
            },
            ...additionalFields
        };
    }; 


    private insertErrorDocument = async (errorDoc, userId) => {
        try {
            const self = this;
            const clientConfig = globalThis.ftClientConfig;
            const templateId =  clientConfig?.errorDocumentTemplate;

            if (!templateId) {
                const msg = 'Could not save error document because there is no error document configured';
                logger.error(msg);
                throw new Error(msg);
            }

            errorDoc.systemHeader.templateId = templateId;

            let inserted : any = await self.indexedDBService.insert(errorDoc);
            
            self.offlineStatusService.incPendingDocumentCount();
            logger.info("Inserted error document: " + inserted.documentId);
        } catch (err) {
            // don't fail the function on error
            logger.error("Error inserting error doc: " + err.message);
        }
    };

    insertErrorDoc = async (documentId, document, error, category, userId) => {
        const errorDoc = this.createErrorDoc(documentId, document, error, category);
        await this.insertErrorDocument(errorDoc, userId);
    };

    insertRuleErrorDoc = async (documentId, document, relatedFields, error, userId) => {
        const errorDoc = this.createErrorDoc(documentId, document, error, "ruleset", relatedFields);
        await this.insertErrorDocument(errorDoc, userId);
    };

    
    async createOfflineFatalErrorDoc(documentId, document, error, userId) {
        
        try{
            await this.insertErrorDoc(documentId, document, error, 'offline', userId);
            return true;
        } catch (err){
            console.log(err);
            return false;
        }
    }
}
